import { render, staticRenderFns } from "./createSecond.vue?vue&type=template&id=7ec091b0&scoped=true&"
import script from "./createSecond.vue?vue&type=script&lang=ts&"
export * from "./createSecond.vue?vue&type=script&lang=ts&"
import style0 from "./createSecond.vue?vue&type=style&index=0&id=7ec091b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec091b0",
  null
  
)

export default component.exports